(function () {
  document
    .querySelectorAll(
      ".header__primary-nav-item a, a.header-sidebar__linklist-button, .header-sidebar__nested-linklist a",
    )
    .forEach((link) => {
      const text = link.textContent.trim().toLowerCase();
      if (text) {
        link.setAttribute("data-text", text);
      }
    });
})();
